import { TEST_LIST, QUESTION, ANSRESULT, TEST_RESULT } from '../constant/ActionTypes';

export const dashRecuder = (state, action) => {
    switch (action.type) {
        case TEST_LIST:
            return {
                ...state,
                testList: action.payload
            };
        case QUESTION:
            return {
                ...state,
                question: action.payload
            };
        case ANSRESULT:
            return {
                ...state,
                ansresult: action.payload
            };
        case TEST_RESULT:
            return {
                ...state,
                testResult: action.payload
            };
        default: {
            return state;
        }
    }
}


// WEBPACK FOOTER //
// ./contexts/reducer/dashRecuder.js